import { initClient, initClientNavigation } from "rwsdk/client";

const clientNavigation = initClientNavigation();
void initClient(clientNavigation);
